import type { MemberMigrationStepStatus } from './schema';

// ─── step completeness ───────────────────────────────────────────────────────
//
// The one definition of "this step needs nothing further from the migration".
// `done` and `skipped` both qualify: a skipped step ran, found nothing it could
// legitimately do, and recorded the reason, so a readiness gate that waited for
// it would wait forever. `pending`, `running` and `failed` do not.
//
// A lone predicate in its own module rather than a method on the recorder: the
// readiness gate reads step rows straight from the database and must reach the
// same answer without constructing a recorder. The recorder's own
// `listIncompleteSteps` is the SQL half of the same rule.

const COMPLETE_STATUSES: ReadonlySet<string> = new Set<MemberMigrationStepStatus>([
  'done',
  'skipped',
]);

export function isMemberMigrationStepComplete(status: string): boolean {
  return COMPLETE_STATUSES.has(status);
}
